import { render, staticRenderFns } from "./ventures-packages.vue?vue&type=template&id=0f67e167&scoped=true"
import script from "./ventures-packages.vue?vue&type=script&lang=js"
export * from "./ventures-packages.vue?vue&type=script&lang=js"
import style0 from "./ventures-packages.vue?vue&type=style&index=0&id=0f67e167&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f67e167",
  null
  
)

export default component.exports